import axios from 'axios';
export const fetchRating = ({
  url,
  hotelId,
  page,
  sort,
  traveledAs,
  splitTreatment,
  lang,
  src,
  hasPhotos,
  hasTextRating,
  recommendation
}) => axios.get(`${url}/v1/ratings/hotel/${hotelId}`, {
  params: {
    from: (page - 1) * 10,
    size: 10,
    traveledAs,
    sort,
    splitTreatment,
    lang,
    src,
    hasPhotos,
    hasTextRating,
    recommendation
  },
  paramsSerializer: params => {
    const requestParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value === null || value === undefined) {
        continue;
      }
      if (Array.isArray(value)) {
        for (const item of value) requestParams.append(key, item);
      } else {
        requestParams.append(key, value);
      }
    }
    return requestParams.toString();
  }
}).then(({
  data
}) => data).catch(() => undefined);